const Api = {
  //Live url
  BASEURL: 'https://backapi.symang.in/api/'

  //Local Url
  // BASEURL: 'http://192.168.1.29/api/'
};
export default Api;
